<script setup lang="ts">
import { useRoute } from "vue-router";

const { breadcrumbs } = useBreadcrumbs();
const localePath = useLocalePath();
const { formatLink } = useInternationalization(localePath);

const route = useRoute();


</script>

<template>
  <div class="breadcrumb block overflow-hidden">
    <div
      class="breadcrumb-inner overflow-hidden"
      v-if="route.path !== '/'"
    >
      <div class="max-w-full overflow-hidden">
        <ul class="flex items-center gap-1 text-sm md:text-base text-grey-600 pt-4 pb-5 md:py-8 truncate">
          <li>
            <NuxtLink
              :to="formatLink(`/`)"
              class="hover:text-primary transition-colors duration-300 truncate max-w-[100px] md:max-w-[200px]"
            >
              {{ $t("home") }}
            </NuxtLink>
          </li>
          <li 
            v-for="(breadcrumb, index) in breadcrumbs"
            :key="breadcrumb.path"
            class="flex items-center gap-2"
          >
            <i class="icon-chevron-right text-[10px]" aria-hidden="true"></i>
            <NuxtLink
              v-if="index !== breadcrumbs.length - 1 && breadcrumb.path"
              :to="formatLink(breadcrumb.path)"
              class="hover:text-primary transition-colors duration-300 truncate max-w-[100px] md:max-w-[200px]"
            >
              {{ breadcrumb.name }}
            </NuxtLink>
            <span v-else class="text-black truncate max-w-[100px] md:max-w-[200px]">{{ breadcrumb.name }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>